export class StoreAddress {
  constructor(
    public id: number,
    public street1: string,
    public street2: string | null = null,
    public street3: string | null = null,
    public city: string,
    public state: string,
    public zipCode: string,
    public lat: number | null = null,
    public lng: number | null = null,
  ) {}

  toString(streetOnly = false): string {
    let address = this.street1
    if (this.street2) {
      address += ` ${this.street2}`
    }
    if (this.street3) {
      address += ` ${this.street3}`
    }
    if (!streetOnly) {
      address += `\n${this.city}, ${this.state} ${this.zipCode}`
    }
    return address
  }

  static fromDynamic(data: { [key: string]: any }) {
    return new StoreAddress(
      data["id"],
      data["street1"],
      data["street2"],
      data["street3"],
      data["city"],
      data["state"],
      data["zip_code"],
      data["latlng"]["lat"],
      data["latlng"]["lng"],
    )
  }
}
